import { render, staticRenderFns } from "./ManageSubmissions.vue?vue&type=template&id=fab4a056&"
import script from "./ManageSubmissions.vue?vue&type=script&lang=js&"
export * from "./ManageSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports